import { NUMBER_1 } from '~shared/constants';
import { GaTrackingHelpersService } from '~shared/modules/ga-tracking/utils/ga-tracking-helpers.service';
import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventName, GATrackingEventType, GaTrackingStringConstantEnum } from '../../constants';
import { Offer, Product } from '~app/modules/product/models';

import get from 'lodash.get';
import { AddToCartEvent } from '~shared/modules/shopping-cart-global/models';
import { PriceTypes } from '~shared/modules/price-type-toggler/models/price-types.enum';
import { Category } from '~app/modules/generic/models';

export class GaTrackingAddToCartGa4Event implements GATrackingEvent {
  constructor(
    private product: Product,
    private event: AddToCartEvent,
    private priceType: PriceTypes,
    private breadcrumbs: Category[],
    private recommendation: boolean,
    private EECLabel: string,
    private previousUrl: string,
    private isBlackDealsEnabled: boolean,
    private searchTerm?: string,
    private itemListName?: string
  ) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.AddToCartGa4;
  }

  getSelectedOffer(): Offer {
    const selectedOffer = this.event.offer;
    return selectedOffer
      ? get(
          this.product?.offers?.filter((offer) => offer.id === selectedOffer),
          '[0]',
          this.product?.bestOffer
        )
      : this.product?.bestOffer;
  }

  getPayload(): GATrackingEventPayload {
    const offer = this.getSelectedOffer();
    const quantity = get(this.event, 'quantity', NUMBER_1);
    return {
      event: GaTrackingEventName.AddToCartGa4,
      gtmCustom: {
        price_type: this.priceType,
        ecommerce: {
          item_list_name: this.itemListName,
          search_term: this.searchTerm,
          currency: GaTrackingStringConstantEnum.EUR,
          items: [
            {
              ...GaTrackingHelpersService.getItemObjectForGA4(
                this.product,
                offer,
                this.priceType,
                this.event?.isVasChecked !== GaTrackingStringConstantEnum.No,
                this.breadcrumbs,
                this.recommendation,
                quantity,
                this.EECLabel,
                this.previousUrl,
                this.isBlackDealsEnabled
              ),
            },
          ],
        },
      },
    };
  }
}
